import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ValidaEdicionResponse } from 'src/app/global/interfaces/valida-edicion-paso-tres-response';
import { ValidacionEdicionService } from 'src/app/global/services/validacion-edicion.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';

@Injectable()
export class ValidacionEdicionProviderVM extends ValidacionEdicionServiceVM {

    private validacionSubject = new BehaviorSubject<boolean>(null);
    getValidacion$ = this.validacionSubject.asObservable();


    constructor(private valEdicionService: ValidacionEdicionService) {
        super();
    }

    setValidaStatus(valor: boolean): void {
        this.validacionSubject.next(valor);
    }


    /**
     * Retorna la respuesta del servicio para verificar el estado de edición de los datos.
     * @returns Respuesta con el estado de modificación de los datos
     */
    public getValidacionEdicion(): Observable<ValidaEdicionResponse> {

        return this.valEdicionService.getValidacionEdicion().pipe(
            map(this.valEdicionResponseOK), catchError(this.valEdicionResponseError)
        );


    }

    private valEdicionResponseOK(resp) {
        return resp;
    }

    private valEdicionResponseError(error) {
        return error;
    }
}
